export const HOST_NAME = 'https://api.cosmic.wolfelabs.tech';
// export const HOST_NAME = 'https://api.marketplace.cosmicuniverse.one';
export const SERVER_BASE_URL = `${HOST_NAME}/api/v1`;
